module.exports = __webpack_public_path__ + "static/media/id.bf9d548d.png";